

const local = {
  // name: 'ORGA MANAGER',
  name: 'LH ORGA MANAGER DEV',
  company: 'LCAG',
  apiService: 'http://localhost:8080/',
  s3Url: 'http://localhost:8080/',
  // apiService: 'https://api.orga.orgadynamics.com/',
  // s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://orga.orgadynamics.com/',
};

const dev = {
  name: 'LH ORGA MANAGER DEV',
  company: 'LCAG',
  apiService: 'https://api.dev.lh.caba.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://dev.lh.caba.orgadynamics.com/',
};

const stage = {
  name: 'LH ORGA MANAGER STAGE',
  company: 'LCAG',
  apiService: 'https://api.stage.lh.caba.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://stage.lh.caba.orgadynamics.com/',
};

const prod = {
  name: 'LH TRISTAR ORGA MANAGER PROD',
  company: 'LCAG',
  apiService: 'https://api.lh.caba.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://lh.caba.orgadynamics.com/'
};

let processEnv = local;

switch (process.env.REACT_APP_STAGE) {
  case 'prod':
    processEnv = prod;
    break;
  case 'dev':
    processEnv = dev;
    break;
  case 'stage':
    processEnv = stage;
    break;
  default: break;
}

export default processEnv;